import React from 'react'
import PropTypes from 'prop-types'
import OnlineIcon from '@/modern/components/OnlineIcon'
import VideoChamadaModal from '@/modern/components/VideoChamadaModal'
import VideoChamadaSucessoModal from '@/modern/components/VideoChamadaSucessoModal'
import CarDeliveryComponent from './CarDelivery'
import TrocaComTrocoComponent from './TrocaComTroco'
import SuperPreco from './SuperPreco'
import VideoChamada from './VideoChamada'

import * as S from './style'

const SealsArea = ({ advertisement, idGuid }) => {
  const { Seller, GoodDeal } = advertisement
  const { SellerType, CarDelivery, TrocaComTroco } = Seller
  const isPJ = SellerType === 'PJ'
  const hasAtLeastOne = CarDelivery || TrocaComTroco || GoodDeal || isPJ || null
  const hasOnlyPJSeal = isPJ && !CarDelivery && !TrocaComTroco && !GoodDeal
  return (
    hasAtLeastOne && (
      <S.SealsArea moreHeight={hasAtLeastOne && !hasOnlyPJSeal && isPJ}>
        <S.AboutTheAd>
          <S.Text>Sobre os diferenciais do anúncio</S.Text>
          {isPJ && <OnlineIcon />}
        </S.AboutTheAd>
        {isPJ && <VideoChamada />}
        {isPJ && <VideoChamadaModal ad={advertisement} idGuid={idGuid} />}
        {isPJ && <VideoChamadaSucessoModal ad={advertisement} />}
        <S.Seals>
          {CarDelivery && <CarDeliveryComponent />}
          {TrocaComTroco && <TrocaComTrocoComponent />}
          {GoodDeal && <SuperPreco />}
        </S.Seals>
      </S.SealsArea>
    )
  )
}

SealsArea.propTypes = {
  idGuid: PropTypes.string.isRequired,
  advertisement: PropTypes.shape({
    Seller: PropTypes.shape({
      SellerType: PropTypes.string.isRequired,
      CarDelivery: PropTypes.bool.isRequired,
      TrocaComTroco: PropTypes.bool.isRequired,
    }),
    GoodDeal: PropTypes.bool,
  }).isRequired,
}

export default SealsArea
